var _path, _g, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _g3, _path8, _g4, _path9, _g5, _path10, _g6, _path11, _g7, _path12, _g8, _path13, _g9, _path14, _g10, _path15, _g11, _path16, _g12, _path17, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g21, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 591,
    height: 344,
    viewBox: "0 0 591 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.4076 0C71.4439 0 64.9292 6.51473 64.9292 14.4784V308.652C64.9292 316.615 71.4439 323.13 79.4076 323.13H506.76C514.724 323.13 521.239 316.615 521.239 308.652V14.4784C521.239 6.51473 514.722 0 506.76 0H79.4076Z",
    fill: "#343A8A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.06,
    filter: "url(#filter0_d_164_2422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.058 326H136.442H30.4849L11.8902 332.1C9.72921 332.809 10.2393 336 12.5136 336H136.442H454.058H577.9C580.191 336 580.683 332.775 578.497 332.091L559.014 326H454.058Z",
    fill: "#010630"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M452.274 316.409H134.501H13C13 316.409 19.0744 323.13 37.5347 323.13H134.503H452.276H549.244C567.7 323.13 573.777 316.409 573.777 316.409H452.274Z",
    fill: "#010630"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M452.274 316.409H134.501H13C13 316.409 19.0744 323.13 37.5347 323.13H134.503H452.276H549.244C567.7 323.13 573.777 316.409 573.777 316.409H452.274Z",
    fill: "#010630"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M573.775 305.66H13V316.407H573.775V305.66Z",
    fill: "#2B306E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M333.111 306.982H254.447C254.447 309.694 256.645 311.89 259.353 311.89H328.204C330.913 311.892 333.111 309.696 333.111 306.982Z",
    fill: "#010630"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_164_2422",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 17,
    width: 435,
    height: 280
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M510.046 17.1394H76.7334V296.669H510.046V17.1394Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_164_2422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516.573 17.553H74.522V35.0046H516.573V17.553Z",
    fill: "#F2F2F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_164_2422",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 17,
    width: 435,
    height: 280
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M510.046 17.1394H76.7334V296.669H510.046V17.1394Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_164_2422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.111 36.4931H196.687L202.635 21.3203H282.161L288.111 36.4931Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_164_2422",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 17,
    width: 435,
    height: 280
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M510.046 17.1394H76.7334V296.669H510.046V17.1394Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_164_2422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516.573 35.0046H74.522V57.6124H516.573V35.0046Z",
    fill: "#B6B7CD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_164_2422",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 17,
    width: 435,
    height: 280
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M510.046 17.1394H76.7334V296.669H510.046V17.1394Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_164_2422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489.204 47.2423C489.204 49.6735 487.215 51.6626 484.784 51.6626H121.581C119.15 51.6626 117.161 49.6735 117.161 47.2423V45.3737C117.161 42.9424 119.15 40.9534 121.581 40.9534H484.786C487.217 40.9534 489.206 42.9424 489.206 45.3737L489.204 47.2423Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_164_2422",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 17,
    width: 435,
    height: 280
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M510.046 17.1394H76.7334V296.669H510.046V17.1394Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_164_2422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.766 36.4931H119.342L125.29 21.3203H204.816L210.766 36.4931Z",
    fill: "#B6B7CD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_164_2422",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 17,
    width: 435,
    height: 280
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M510.046 17.1394H76.7334V296.669H510.046V17.1394Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_164_2422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.5742 26.4771C86.5742 28.5188 84.9201 30.1729 82.8784 30.1729C80.8367 30.1729 79.1826 28.5188 79.1826 26.4771C79.1826 24.4372 80.8386 22.7812 82.8784 22.7812C84.9183 22.7812 86.5742 24.4372 86.5742 26.4771Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_164_2422",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 17,
    width: 435,
    height: 280
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M510.046 17.1394H76.7334V296.669H510.046V17.1394Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_164_2422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.7173 26.4771C98.7173 28.5188 97.0632 30.1729 95.0215 30.1729C92.9797 30.1729 91.3257 28.5188 91.3257 26.4771C91.3257 24.4372 92.9797 22.7812 95.0215 22.7812C97.0613 22.7812 98.7173 24.4372 98.7173 26.4771Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_164_2422",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 17,
    width: 435,
    height: 280
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M510.046 17.1394H76.7334V296.669H510.046V17.1394Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_164_2422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.861 26.4771C110.861 28.5188 109.205 30.1729 107.166 30.1729C105.124 30.1729 103.47 28.5188 103.47 26.4771C103.47 24.4372 105.124 22.7812 107.166 22.7812C109.205 22.7812 110.861 24.4372 110.861 26.4771Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_164_2422",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 17,
    width: 435,
    height: 280
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M510.046 17.1394H76.7334V296.669H510.046V17.1394Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_164_2422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516.573 57.6128H74.522V255.535H516.573V57.6128Z",
    fill: "#F2F2F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_164_2422",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 17,
    width: 435,
    height: 280
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M510.046 17.1394H76.7334V296.669H510.046V17.1394Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_164_2422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.1636 305.66V255.535H519.335V305.66",
    fill: "#010630"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_164_2422",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 17,
    width: 435,
    height: 280
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M510.046 17.1394H76.7334V296.669H510.046V17.1394Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_164_2422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.639 264.125H182.988C182.436 264.125 181.988 264.572 181.988 265.125V281.943C181.988 282.495 182.436 282.943 182.988 282.943H361.639C362.192 282.943 362.639 282.495 362.639 281.943V265.125C362.639 264.572 362.192 264.125 361.639 264.125Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_164_2422",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 17,
    width: 435,
    height: 280
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M510.046 17.1394H76.7334V296.669H510.046V17.1394Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_164_2422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.135 267.72C411.135 268.984 410.1 270.019 408.836 270.019H371.612C370.346 270.019 369.312 268.986 369.312 267.72V264.522C369.312 263.258 370.346 262.223 371.612 262.223H408.836C410.1 262.223 411.135 263.258 411.135 264.522V267.72Z",
    fill: "#FF00B1"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_164_2422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M539.817 92.2734H343.53C337.455 92.2734 332.53 97.1983 332.53 103.273V150.609H539.817C545.892 150.609 550.817 145.684 550.817 139.609V103.273C550.817 97.1983 545.892 92.2734 539.817 92.2734Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.897 91.0012H343.912C337.837 91.0012 332.912 95.9261 332.912 102.001V149.34H537.897C543.972 149.34 548.897 144.415 548.897 138.34V102.001C548.897 95.9261 543.972 91.0012 537.897 91.0012Z",
    fill: "#010630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.083 103.564H400.275V107.328H451.083V103.564Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.546 103.564H454.847V107.328H475.546V103.564Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.083 133.673H400.275V137.436H451.083V133.673Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.546 133.673H454.847V137.436H475.546V133.673Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.063 126.145H464.255V129.909H515.063V126.145Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 126.145H518.827V129.909H532V126.145Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.954 103.564H479.309V107.328H484.954V103.564Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.891 103.564H488.718V107.328H501.891V103.564Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.709 103.564H507.536V107.328H520.709V103.564Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.999 103.564H524.472V107.328H531.999V103.564Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.856 111.091H400.275V114.855H422.856V111.091Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.029 111.091H426.62V114.855H436.029V111.091Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.072 111.091H439.792V114.855H483.072V111.091Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.654 111.091H486.836V114.855H505.654V111.091Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.999 111.091H509.418V114.855H531.999V111.091Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.029 118.618H400.275V122.382H436.029V118.618Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.373 118.618H439.792V122.382H462.373V118.618Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.546 118.618H466.137V122.382H475.546V118.618Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.009 118.618H479.309V122.382H500.009V118.618Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.856 126.145H400.275V129.909H422.856V126.145Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.319 126.145H426.62V129.909H447.319V126.145Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.491 126.145H451.083V129.909H460.491V126.145Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.999 118.618H503.772V122.382H531.999V118.618Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.984 101.683H365.349C357.617 101.683 351.349 107.951 351.349 115.683V125.318C351.349 133.05 357.617 139.318 365.349 139.318H374.984C382.716 139.318 388.984 133.05 388.984 125.318V115.683C388.984 107.951 382.716 101.683 374.984 101.683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.817 92.2734H343.53C337.455 92.2734 332.53 97.1983 332.53 103.273V150.609H539.817C545.892 150.609 550.817 145.684 550.817 139.609V103.273C550.817 97.1983 545.892 92.2734 539.817 92.2734Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.897 91.0012H343.912C337.837 91.0012 332.912 95.9261 332.912 102.001V149.34H537.897C543.972 149.34 548.897 144.415 548.897 138.34V102.001C548.897 95.9261 543.972 91.0012 537.897 91.0012Z",
    fill: "#010630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.083 103.564H400.275V107.328H451.083V103.564Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.546 103.564H454.847V107.328H475.546V103.564Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.083 133.673H400.275V137.436H451.083V133.673Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.546 133.673H454.847V137.436H475.546V133.673Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.063 126.145H464.255V129.909H515.063V126.145Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 126.145H518.827V129.909H532V126.145Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.954 103.564H479.309V107.328H484.954V103.564Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.891 103.564H488.718V107.328H501.891V103.564Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.709 103.564H507.536V107.328H520.709V103.564Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.999 103.564H524.472V107.328H531.999V103.564Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.856 111.091H400.275V114.855H422.856V111.091Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.029 111.091H426.62V114.855H436.029V111.091Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.072 111.091H439.792V114.855H483.072V111.091Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.654 111.091H486.836V114.855H505.654V111.091Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.999 111.091H509.418V114.855H531.999V111.091Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.029 118.618H400.275V122.382H436.029V118.618Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.373 118.618H439.792V122.382H462.373V118.618Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.546 118.618H466.137V122.382H475.546V118.618Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.009 118.618H479.309V122.382H500.009V118.618Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.856 126.145H400.275V129.909H422.856V126.145Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.319 126.145H426.62V129.909H447.319V126.145Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.491 126.145H451.083V129.909H460.491V126.145Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.999 118.618H503.772V122.382H531.999V118.618Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.984 101.683H365.349C357.617 101.683 351.349 107.951 351.349 115.683V125.318C351.349 133.05 357.617 139.318 365.349 139.318H374.984C382.716 139.318 388.984 133.05 388.984 125.318V115.683C388.984 107.951 382.716 101.683 374.984 101.683Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_164_2422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.6621 75.947L88.6621 263.216H180.909V75.947H88.6621Z",
    fill: "#FDDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.083 102.292H99.9531V107.937H126.083V102.292Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.47 102.292H128.18V107.937H139.47V102.292Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.083 147.455H99.9531V153.1H126.083V147.455Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.61 147.455H127.965V153.1H138.61V147.455Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.825 136.164H132.695V141.809H158.825V136.164Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.482 136.164H160.708V141.809H167.482V136.164Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.052 102.292H141.353V107.937H162.052V102.292Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.805 102.292H163.934V107.937H167.805V102.292Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.566 113.583H99.9531V119.228H111.566V113.583Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.287 113.583H113.448V119.228H118.287V113.583Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.427 113.583H120.168V119.228H142.427V113.583Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.987 113.583H144.309V119.228H153.987V113.583Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.482 113.583H155.869V119.228H167.482V113.583Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.341 124.873H99.9531V130.519H118.341V124.873Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.836 124.873H120.223V130.519H131.836V124.873Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.557 124.873H133.718V130.519H138.557V124.873Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.083 124.873H140.438V130.519H151.083V124.873Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.566 136.164H99.9531V141.809H111.566V136.164Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.061 136.164H113.125V141.809H130.061V136.164Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.482 124.873H152.966V130.519H167.482V124.873Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.083 162.509H99.9531V168.154H126.083V162.509Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.47 162.509H128.18V168.154H139.47V162.509Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.083 207.672H99.9531V213.317H126.083V207.672Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.61 207.672H127.965V213.317H138.61V207.672Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.697 207.672H141.353V213.317H167.697V207.672Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.825 196.381H132.695V202.026H158.825V196.381Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.482 196.381H160.708V202.026H167.482V196.381Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.052 162.509H141.353V168.154H162.052V162.509Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.805 162.509H163.934V168.154H167.805V162.509Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.566 173.8H99.9531V179.445H111.566V173.8Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.287 173.8H113.448V179.445H118.287V173.8Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.427 173.8H120.168V179.445H142.427V173.8Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.987 173.8H144.309V179.445H153.987V173.8Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.482 173.8H155.869V179.445H167.482V173.8Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.341 185.091H99.9531V190.736H118.341V185.091Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.836 185.091H120.223V190.736H131.836V185.091Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.566 196.381H99.9531V202.026H111.566V196.381Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.061 196.381H113.125V202.026H130.061V196.381Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.697 185.091H135.707V190.736H167.697V185.091Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.589 218.963H99.9531V224.608H137.589V218.963Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.052 218.963H141.353V224.608H162.052V218.963Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.805 218.963H163.934V224.608H167.805V218.963Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.566 230.253H99.9531V235.899H111.566V230.253Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.287 230.253H113.448V235.899H118.287V230.253Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.427 230.253H120.168V235.899H142.427V230.253Z",
    fill: "#FF00B1"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter3_d_164_2422)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M226.033 222.146L226.033 134.281H182.752V222.146H226.033Z",
    fill: "#FDDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.57 145.369H188.909V147.913H206.57V145.369Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.705 145.369H207.986V147.913H220.705V145.369Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.57 165.719H188.909V168.263H206.57V165.719Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.705 165.719H207.986V168.263H220.705V165.719Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.706 160.631H210.531V163.175H220.706V160.631Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.758 150.458H188.909V153.001H196.758V150.458Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.302 150.458H198.031V153.001H201.302V150.458Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.706 150.458H202.9V153.001H220.706V150.458Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.337 155.544H188.909V158.088H201.337V155.544Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.458 155.544H202.609V158.088H210.458V155.544Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.706 155.544H211.803V158.088H220.706V155.544Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.758 160.631H188.909V163.175H196.758V160.631Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.478 160.631H198.031V163.175H209.478V160.631Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.57 170.807H188.909V173.351H206.57V170.807Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.705 170.807H207.986V173.351H220.705V170.807Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.57 191.157H188.909V193.701H206.57V191.157Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.705 191.157H207.986V193.701H220.705V191.157Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.706 186.07H210.531V188.614H220.706V186.07Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.758 175.896H188.909V178.439H196.758V175.896Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.302 175.896H198.031V178.439H201.302V175.896Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.706 175.896H202.9V178.439H220.706V175.896Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.337 180.982H188.909V183.526H201.337V180.982Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.458 180.982H202.609V183.526H210.458V180.982Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.706 180.982H211.803V183.526H220.706V180.982Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.758 186.07H188.909V188.614H196.758V186.07Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.478 186.07H198.031V188.614H209.478V186.07Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.57 196.245H188.909V198.788H206.57V196.245Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.705 196.245H207.986V198.788H220.705V196.245Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.758 201.332H188.909V203.876H196.758V201.332Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.302 201.332H198.031V203.876H201.302V201.332Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.706 201.332H202.9V203.876H220.706V201.332Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.337 206.421H188.909V208.964H201.337V206.421Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.458 206.421H202.609V208.964H210.458V206.421Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.706 206.421H211.803V208.964H220.706V206.421Z",
    fill: "#FF00B1"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35,
    filter: "url(#filter4_d_164_2422)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M317.477 186.393V98.5286L274.196 98.5286V186.393H317.477Z",
    fill: "#FDDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.013 109.616H280.352V112.16H298.013V109.616Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.148 109.616H299.429V112.16H312.148V109.616Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.013 129.966H280.352V132.51H298.013V129.966Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.148 129.966H299.429V132.51H312.148V129.966Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.148 124.878H301.973V127.421H312.148V124.878Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.201 114.704H280.352V117.248H288.201V114.704Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.743 114.704H289.472V117.248H292.743V114.704Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.148 114.704H294.341V117.248H312.148V114.704Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.78 119.79H280.352V122.334H292.78V119.79Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.9 119.79H294.051V122.334H301.9V119.79Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.148 119.79H303.245V122.334H312.148V119.79Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.201 124.878H280.352V127.421H288.201V124.878Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.919 124.878H289.472V127.421H300.919V124.878Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.013 135.053H280.352V137.597H298.013V135.053Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.148 135.053H299.429V137.597H312.148V135.053Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.013 155.404H280.352V157.948H298.013V155.404Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.148 155.404H299.429V157.948H312.148V155.404Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.148 150.316H301.973V152.86H312.148V150.316Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.201 140.142H280.352V142.686H288.201V140.142Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.743 140.142H289.472V142.686H292.743V140.142Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.148 140.142H294.341V142.686H312.148V140.142Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.78 145.229H280.352V147.773H292.78V145.229Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.9 145.229H294.051V147.773H301.9V145.229Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.148 145.229H303.245V147.773H312.148V145.229Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.201 150.316H280.352V152.86H288.201V150.316Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.919 150.316H289.472V152.86H300.919V150.316Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.013 160.491H280.352V163.035H298.013V160.491Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.148 160.491H299.429V163.035H312.148V160.491Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.201 165.579H280.352V168.123H288.201V165.579Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.743 165.579H289.472V168.123H292.743V165.579Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.148 165.579H294.341V168.123H312.148V165.579Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.78 170.667H280.352V173.211H292.78V170.667Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.9 170.667H294.051V173.211H301.9V170.667Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.148 170.667H303.245V173.211H312.148V170.667Z",
    fill: "#FF00B1"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter5_d_164_2422)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M326.885 243.992V205.79H308.067V243.992H326.885Z",
    fill: "#FDDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.422 210.611H310.744V211.717H318.422V210.611Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.569 210.611H319.039V211.717H324.569V210.611Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.422 219.459H310.744V220.565H318.422V219.459Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.569 219.459H319.039V220.565H324.569V219.459Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.568 217.247H320.145V218.353H324.568V217.247Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.156 212.824H310.744V213.93H314.156V212.824Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.131 212.824H314.709V213.93H316.131V212.824Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.569 212.824H316.827V213.93H324.569V212.824Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.147 215.035H310.744V216.141H316.147V215.035Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.114 215.035H316.701V216.141H320.114V215.035Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.569 215.035H320.698V216.141H324.569V215.035Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.156 217.247H310.744V218.353H314.156V217.247Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.686 217.247H314.709V218.353H319.686V217.247Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.422 221.671H310.744V222.777H318.422V221.671Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.569 221.671H319.039V222.777H324.569V221.671Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.422 230.52H310.744V231.626H318.422V230.52Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.569 230.52H319.039V231.626H324.569V230.52Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.568 228.307H320.145V229.413H324.568V228.307Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.156 223.884H310.744V224.99H314.156V223.884Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.131 223.884H314.709V224.99H316.131V223.884Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.569 223.884H316.827V224.99H324.569V223.884Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.147 226.095H310.744V227.201H316.147V226.095Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.114 226.095H316.701V227.201H320.114V226.095Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.569 226.095H320.698V227.201H324.569V226.095Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.156 228.307H310.744V229.413H314.156V228.307Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.686 228.307H314.709V229.413H319.686V228.307Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.422 232.731H310.744V233.837H318.422V232.731Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.569 232.731H319.039V233.837H324.569V232.731Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.156 234.943H310.744V236.049H314.156V234.943Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.131 234.943H314.709V236.049H316.131V234.943Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.569 234.943H316.827V236.049H324.569V234.943Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.147 237.155H310.744V238.261H316.147V237.155Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.114 237.155H316.701V238.261H320.114V237.155Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.569 237.155H320.698V238.261H324.569V237.155Z",
    fill: "#FF00B1"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter6_d_164_2422)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M255.488 143.338L255.488 55.2476L212.096 55.2476V143.338H255.488Z",
    fill: "#FDDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.975 66.365H218.268V68.9153H235.975V66.365Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.147 66.365H237.395V68.9153H250.147V66.365Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.975 86.7671H218.268V89.3174H235.975V86.7671Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.147 86.7671H237.395V89.3174H250.147V86.7671Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.148 81.6655H239.946V84.2159H250.148V81.6655Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.138 71.4648H218.268V74.0152H226.138V71.4648Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.691 71.4648H227.412V74.0152H230.691V71.4648Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.145 71.4648H232.293V74.0152H250.145V71.4648Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.728 76.5657H218.268V79.116H230.728V76.5657Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.873 76.5657H232.003V79.116H239.873V76.5657Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.146 76.5657H241.22V79.116H250.146V76.5657Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.138 81.6655H218.268V84.2159H226.138V81.6655Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.889 81.6655H227.412V84.2159H238.889V81.6655Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.975 91.8677H218.268V94.418H235.975V91.8677Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.147 91.8677H237.395V94.418H250.147V91.8677Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.975 112.27H218.268V114.82H235.975V112.27Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.147 112.27H237.395V114.82H250.147V112.27Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.148 107.17H239.946V109.72H250.148V107.17Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.138 96.9678H218.268V99.5181H226.138V96.9678Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.691 96.9678H227.412V99.5181H230.691V96.9678Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.145 96.9678H232.293V99.5181H250.145V96.9678Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.728 102.069H218.268V104.619H230.728V102.069Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.873 102.069H232.003V104.619H239.873V102.069Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.146 102.069H241.22V104.619H250.146V102.069Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.138 107.17H218.268V109.72H226.138V107.17Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.889 107.17H227.412V109.72H238.889V107.17Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.975 117.37H218.268V119.92H235.975V117.37Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.147 117.37H237.395V119.92H250.147V117.37Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.138 122.472H218.268V125.022H226.138V122.472Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.691 122.472H227.412V125.022H230.691V122.472Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.145 122.472H232.293V125.022H250.145V122.472Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.728 127.572H218.268V130.122H230.728V127.572Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.873 127.572H232.003V130.122H239.873V127.572Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.146 127.572H241.22V130.122H250.146V127.572Z",
    fill: "#FF00B1"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    filter: "url(#filter7_d_164_2422)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M300.896 276.102V146.104H236.86L236.86 276.102H300.896Z",
    fill: "#FDDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.098 162.509H245.968V166.273H272.098V162.509Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.013 162.509H274.195V166.273H293.013V162.509Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.098 192.618H245.968V196.381H272.098V192.618Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.013 192.618H274.195V196.381H293.013V192.618Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.013 185.091H277.958V188.854H293.013V185.091Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.582 170.036H245.968V173.8H257.582V170.036Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.302 170.036H259.463V173.8H264.302V170.036Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.013 170.036H266.668V173.8H293.013V170.036Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.356 177.563H245.968V181.327H264.356V177.563Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.85 177.563H266.237V181.327H277.85V177.563Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.013 177.563H279.84V181.327H293.013V177.563Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.582 185.091H245.968V188.854H257.582V185.091Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.399 185.091H259.463V188.854H276.399V185.091Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.098 200.145H245.968V203.908H272.098V200.145Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.013 200.145H274.195V203.908H293.013V200.145Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.098 230.254H245.968V234.017H272.098V230.254Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.013 230.254H274.195V234.017H293.013V230.254Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.013 222.727H277.958V226.49H293.013V222.727Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.582 207.672H245.968V211.436H257.582V207.672Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.302 207.672H259.463V211.436H264.302V207.672Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.013 207.672H266.668V211.436H293.013V207.672Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.356 215.199H245.968V218.963H264.356V215.199Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.85 215.199H266.237V218.963H277.85V215.199Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.013 215.199H279.84V218.963H293.013V215.199Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.582 222.727H245.968V226.49H257.582V222.727Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.399 222.727H259.463V226.49H276.399V222.727Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.098 237.781H245.968V241.544H272.098V237.781Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.013 237.781H274.195V241.544H293.013V237.781Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.582 245.308H245.968V249.071H257.582V245.308Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.302 245.308H259.463V249.071H264.302V245.308Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.013 245.308H266.668V249.071H293.013V245.308Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.356 252.835H245.968V256.599H264.356V252.835Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.85 252.835H266.237V256.599H277.85V252.835Z",
    fill: "#FF00B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.013 252.835H279.84V256.599H293.013V252.835Z",
    fill: "#FF00B1"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M378.165 114.667C378.165 114.667 374.23 115.512 374.446 118.858C374.479 119.947 374.958 120.981 375.78 121.735L377.529 123.36",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M378.845 119.218L381.085 121.103",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M374.446 124.717C374.446 124.717 375.03 127.507 377.894 127.734",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M361.364 114.779C361.609 114.802 361.85 114.851 362.083 114.927C363.755 115.45 365.069 116.948 365.069 118.632L364.985 123.036",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M360.434 119.162L358.181 121.298L360.315 123.315",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M361.338 127.638H364.324",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M361.08 119.203C361.503 119.203 361.846 118.875 361.846 118.47C361.846 118.066 361.503 117.738 361.08 117.738C360.658 117.738 360.315 118.066 360.315 118.47C360.315 118.875 360.658 119.203 361.08 119.203Z",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M360.843 124.663C361.266 124.663 361.608 124.335 361.608 123.93C361.608 123.525 361.266 123.197 360.843 123.197C360.421 123.197 360.078 123.525 360.078 123.93C360.078 124.335 360.421 124.663 360.843 124.663Z",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M364.987 124.606C365.41 124.606 365.752 124.277 365.752 123.873C365.752 123.468 365.41 123.14 364.987 123.14C364.565 123.14 364.222 123.468 364.222 123.873C364.222 124.277 364.565 124.606 364.987 124.606Z",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M365.088 128.419C365.511 128.419 365.853 128.091 365.853 127.686C365.853 127.282 365.511 126.953 365.088 126.953C364.666 126.953 364.323 127.282 364.323 127.686C364.323 128.091 364.666 128.419 365.088 128.419Z",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M374.352 124.606C374.775 124.606 375.117 124.277 375.117 123.873C375.117 123.468 374.775 123.14 374.352 123.14C373.93 123.14 373.587 123.468 373.587 123.873C373.587 124.277 373.93 124.606 374.352 124.606Z",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M378.223 124.606C378.646 124.606 378.988 124.277 378.988 123.873C378.988 123.468 378.646 123.14 378.223 123.14C377.801 123.14 377.458 123.468 377.458 123.873C377.458 124.277 377.801 124.606 378.223 124.606Z",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M382.374 123.888C382.374 125.942 380.615 127.608 378.445 127.608C378.367 127.608 378.292 127.608 378.216 127.608C378.216 127.666 378.216 127.724 378.216 127.784C378.216 129.838 376.457 131.504 374.287 131.504C373.612 131.511 372.946 131.345 372.353 131.023C371.761 130.702 371.26 130.234 370.9 129.666C370.587 129.151 370.425 128.56 370.431 127.959V114.631C370.424 114.087 370.557 113.551 370.817 113.073C371.166 112.465 371.672 111.961 372.282 111.613C372.892 111.265 373.584 111.085 374.287 111.091C376.457 111.091 378.216 112.759 378.216 114.815H378.358C380.527 114.815 382.286 116.48 382.286 118.536C382.286 119.031 382.183 119.52 381.985 119.974C381.787 120.428 381.497 120.836 381.135 121.174C381.523 121.513 381.834 121.931 382.047 122.398C382.261 122.866 382.372 123.374 382.374 123.888Z",
    stroke: "#010630",
    strokeWidth: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M356.995 123.894C356.996 124.385 357.1 124.871 357.301 125.323C357.501 125.776 357.795 126.187 358.165 126.532C358.534 126.878 358.972 127.151 359.454 127.336C359.936 127.521 360.451 127.615 360.971 127.611C361.05 127.611 361.128 127.611 361.205 127.611C361.205 127.668 361.205 127.727 361.205 127.786C361.213 128.606 361.504 129.4 362.035 130.048C362.566 130.696 363.308 131.162 364.146 131.375C364.984 131.588 365.873 131.537 366.677 131.228C367.481 130.92 368.156 130.371 368.599 129.667C368.917 129.148 369.08 128.558 369.073 127.959V114.648C369.079 114.108 368.945 113.575 368.683 113.096C368.27 112.354 367.605 111.765 366.796 111.421C365.987 111.078 365.079 111 364.217 111.2C363.355 111.4 362.589 111.866 362.04 112.524C361.492 113.183 361.192 113.995 361.19 114.833H361.045C360.525 114.83 360.01 114.925 359.528 115.111C359.047 115.297 358.609 115.571 358.24 115.918C357.872 116.264 357.579 116.676 357.379 117.129C357.18 117.582 357.077 118.068 357.077 118.559C357.076 119.05 357.178 119.537 357.379 119.99C357.579 120.443 357.874 120.854 358.245 121.199C357.852 121.543 357.538 121.96 357.323 122.424C357.108 122.887 356.996 123.388 356.995 123.894Z",
    stroke: "#010630",
    strokeWidth: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M378.252 119.318C378.674 119.318 379.017 118.99 379.017 118.585C379.017 118.18 378.674 117.852 378.252 117.852C377.829 117.852 377.487 118.18 377.487 118.585C377.487 118.99 377.829 119.318 378.252 119.318Z",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_164_2422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M539.817 163.171H343.531C337.456 163.171 332.531 168.096 332.531 174.171V221.506H539.817C545.893 221.506 550.817 216.582 550.817 210.506V174.171C550.817 168.096 545.893 163.171 539.817 163.171Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.899 161.899H343.914C337.838 161.899 332.914 166.824 332.914 172.899V220.238H537.899C543.974 220.238 548.899 215.313 548.899 209.238V172.899C548.899 166.824 543.974 161.899 537.899 161.899Z",
    fill: "#2B306E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.857 178.835H400.275V182.599H422.857V178.835Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.546 178.835H426.62V182.599H475.546V178.835Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.064 201.417H464.256V205.18H515.064V201.417Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.956 178.835H479.311V182.599H484.956V178.835Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 178.835H488.719V182.599H532V178.835Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.857 186.363H400.275V190.126H422.857V186.363Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.029 186.363H426.62V190.126H436.029V186.363Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.256 186.363H439.792V190.126H464.256V186.363Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.074 186.363H468.02V190.126H483.074V186.363Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.655 186.363H486.837V190.126H505.655V186.363Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.001 186.363H509.419V190.126H532.001V186.363Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.803 193.889H400.275V197.653H407.803V193.889Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.601 193.889H439.792V197.653H490.601V193.889Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.03 193.889H411.566V197.653H436.03V193.889Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.01 193.889H494.365V197.653H500.01V193.889Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.566 201.417H400.275V205.18H411.566V201.417Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.32 201.417H415.33V205.18H447.32V201.417Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.492 201.417H451.083V205.18H460.492V201.417Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 193.889H503.773V197.653H532V193.889Z",
    fill: "#ECEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.985 172.58H365.349C357.617 172.58 351.349 178.848 351.349 186.58V196.216C351.349 203.948 357.617 210.216 365.349 210.216H374.985C382.717 210.216 388.985 203.948 388.985 196.216V186.58C388.985 178.848 382.717 172.58 374.985 172.58Z",
    fill: "white"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M378.165 185.565C378.165 185.565 374.23 186.41 374.446 189.756C374.479 190.846 374.958 191.879 375.78 192.633L377.529 194.258",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M378.845 190.115L381.085 192.001",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M374.446 195.615C374.446 195.615 375.03 198.405 377.894 198.633",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M361.364 185.677C361.609 185.7 361.85 185.749 362.083 185.824C363.755 186.347 365.069 187.845 365.069 189.53L364.985 193.934",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M360.434 190.059L358.181 192.196L360.315 194.213",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M361.338 198.535H364.324",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M361.08 190.102C361.503 190.102 361.846 189.773 361.846 189.369C361.846 188.964 361.503 188.636 361.08 188.636C360.658 188.636 360.315 188.964 360.315 189.369C360.315 189.773 360.658 190.102 361.08 190.102Z",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M360.843 195.56C361.266 195.56 361.608 195.232 361.608 194.827C361.608 194.423 361.266 194.094 360.843 194.094C360.421 194.094 360.078 194.423 360.078 194.827C360.078 195.232 360.421 195.56 360.843 195.56Z",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M364.987 195.503C365.41 195.503 365.752 195.175 365.752 194.77C365.752 194.365 365.41 194.037 364.987 194.037C364.565 194.037 364.222 194.365 364.222 194.77C364.222 195.175 364.565 195.503 364.987 195.503Z",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M365.088 199.317C365.511 199.317 365.853 198.989 365.853 198.585C365.853 198.18 365.511 197.852 365.088 197.852C364.666 197.852 364.323 198.18 364.323 198.585C364.323 198.989 364.666 199.317 365.088 199.317Z",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M374.352 195.503C374.775 195.503 375.117 195.175 375.117 194.77C375.117 194.365 374.775 194.037 374.352 194.037C373.93 194.037 373.587 194.365 373.587 194.77C373.587 195.175 373.93 195.503 374.352 195.503Z",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M378.223 195.503C378.646 195.503 378.988 195.175 378.988 194.77C378.988 194.365 378.646 194.037 378.223 194.037C377.801 194.037 377.458 194.365 377.458 194.77C377.458 195.175 377.801 195.503 378.223 195.503Z",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M382.374 194.786C382.374 196.84 380.615 198.506 378.445 198.506C378.367 198.506 378.292 198.506 378.216 198.506C378.216 198.564 378.216 198.622 378.216 198.682C378.216 200.736 376.457 202.402 374.287 202.402C373.612 202.409 372.946 202.243 372.353 201.921C371.761 201.599 371.26 201.132 370.9 200.564C370.587 200.049 370.425 199.458 370.431 198.857V185.529C370.424 184.985 370.557 184.449 370.817 183.971C371.166 183.363 371.672 182.859 372.282 182.511C372.892 182.163 373.584 181.983 374.287 181.989C376.457 181.989 378.216 183.657 378.216 185.713H378.358C380.527 185.713 382.286 187.378 382.286 189.434C382.286 189.929 382.183 190.418 381.985 190.872C381.787 191.326 381.497 191.734 381.135 192.072C381.523 192.411 381.834 192.829 382.047 193.296C382.261 193.764 382.372 194.272 382.374 194.786Z",
    stroke: "#010630",
    strokeWidth: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M356.995 194.792C356.996 195.283 357.1 195.768 357.301 196.221C357.501 196.674 357.795 197.085 358.165 197.43C358.534 197.776 358.972 198.049 359.454 198.234C359.936 198.419 360.451 198.512 360.971 198.509C361.05 198.509 361.128 198.509 361.205 198.509C361.205 198.566 361.205 198.625 361.205 198.684C361.213 199.504 361.504 200.298 362.035 200.946C362.566 201.594 363.308 202.06 364.146 202.273C364.984 202.486 365.873 202.435 366.677 202.126C367.481 201.818 368.156 201.269 368.599 200.565C368.917 200.046 369.08 199.456 369.073 198.857V185.546C369.079 185.006 368.945 184.473 368.683 183.993C368.27 183.252 367.605 182.663 366.796 182.319C365.987 181.976 365.079 181.898 364.217 182.098C363.355 182.297 362.589 182.764 362.04 183.422C361.492 184.081 361.192 184.893 361.19 185.731H361.045C360.525 185.728 360.01 185.823 359.528 186.009C359.047 186.195 358.609 186.469 358.24 186.816C357.872 187.162 357.579 187.574 357.379 188.027C357.18 188.48 357.077 188.966 357.077 189.457C357.076 189.948 357.178 190.435 357.379 190.888C357.579 191.341 357.874 191.752 358.245 192.097C357.852 192.441 357.538 192.858 357.323 193.322C357.108 193.785 356.996 194.286 356.995 194.792Z",
    stroke: "#010630",
    strokeWidth: 0.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M378.252 190.216C378.674 190.216 379.017 189.887 379.017 189.483C379.017 189.078 378.674 188.75 378.252 188.75C377.829 188.75 377.487 189.078 377.487 189.483C377.487 189.887 377.829 190.216 378.252 190.216Z",
    stroke: "#FF00B1",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_164_2422",
    x: 6.51172,
    y: 326,
    width: 577.39,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_2422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_2422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_164_2422",
    x: 328.53,
    y: 91.0012,
    width: 226.287,
    height: 68.6074,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_2422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_2422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_164_2422",
    x: 82.6621,
    y: 72.947,
    width: 104.247,
    height: 199.269,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_2422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_2422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_164_2422",
    x: 176.752,
    y: 131.281,
    width: 55.2808,
    height: 99.8645,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_2422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_2422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_164_2422",
    x: 268.196,
    y: 95.5286,
    width: 55.2808,
    height: 99.8645,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_2422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_2422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_164_2422",
    x: 302.067,
    y: 202.79,
    width: 30.8179,
    height: 50.2019,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_2422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_2422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_164_2422",
    x: 206.096,
    y: 52.2476,
    width: 55.3926,
    height: 100.091,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_2422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_2422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_164_2422",
    x: 230.86,
    y: 143.104,
    width: 76.0352,
    height: 141.997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_2422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_2422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_164_2422",
    x: 328.531,
    y: 161.899,
    width: 226.287,
    height: 68.6072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_2422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_2422",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage2);
export default __webpack_public_path__ + "static/media/Image2.cd51ac6836f2ddeaa94c2176baa2393e.svg";
export { ForwardRef as ReactComponent };